<template>
  <div
    v-loading="editLoading"
    :element-loading-text="$t('loading')"
    class="container">
    <!-- 表单 -->
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      size="small"
      label-width="125px">
      <el-row :gutter="40">
        <el-col :span="24">
          <el-form-item :label="$t('oldPassword')" prop="password">
            <el-input
              type="password"
              v-model="form.password"
              :placeholder="$t('importOldPwd')"
              show-password
              autocomplete="new-password">
            </el-input>
          </el-form-item>
           <el-form-item :label="$t('newPwd')" prop="password2">
            <el-input
              type="password"
              v-model="form.password2"
              :placeholder="$t('importNewPwd')"
              show-password
              autocomplete="new-password">
            </el-input>
          </el-form-item>
           <el-form-item :label="$t('confirmPwd')" prop="password3">
            <el-input
              type="password"
              v-model="form.password3"
              :placeholder="$t('confirmAgain')"
              show-password
              autocomplete="new-password">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { MD5 } from '@/utils/crypto';
import {
  companyMixin,
  detailMixin,
  saveMixin
} from '@/mixins';

import {
  UpdatePwd
} from '@/api/system/user/api';

export default {
  name: 'SystemUserAdd',
  components: {
  },
  mixins: [
    companyMixin,
    detailMixin,
    saveMixin
  ],
  data() {
    return {
      form: {
        password: '', // 密码
        password2: '', // 新密码
        password3: ''
      },
      rules: {
        password: [
          {
            pattern: /(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,20}/,
            message: this.$t('importPwdErr'),
            trigger: 'blur'
          }
        ],
        password2: [
          {
            pattern: /(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,20}/,
            message: this.$t('importPwdErr'),
            trigger: 'blur'
          }
        ],
        password3: [
          {
            pattern: /(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,20}/,
            message: this.$t('importPwdErr'),
            trigger: 'blur'
          }
        ]
      }
    };
  },
  created() {
  },
  methods: {
    // 提交保存
    async handleSubmit() {
      const { password, password2, password3 } = this.form;
      if (password2 !== password3) {
        return { code: 1, message: this.$t('pwdNotEqual') };
      }
      const result = await UpdatePwd({
        password: MD5(MD5(password).toUpperCase()).toUpperCase(),
        password2: MD5(MD5(password2).toUpperCase()).toUpperCase()
      });
      if (result.code === 0) {
        this.$store.dispatch('resetToken');
        if (this.$keycloak && this.$keycloak.authenticated) {
          this.$keycloak.logoutFn();
        } else {
          this.$router.replace({
            path: '/home/login',
            query: {
              redirect: this.$route.fullPath
            }
          });
        }
      }
      return result;
    }
  }
};
</script>